
import classes from './PushBottom.module.scss';
import Ajax from '../../../../../Handler/Ajax';

declare var _loginMethodSmsOtpUrl: any;
declare function Translate(key: string): string;


const PushBottom = (props) => {

    const backToMainClick = () => {
        Ajax.ResetUserStatus()
            .then(() => {                                  
                window.location = _loginMethodSmsOtpUrl;
            })
            .catch((error) => {                                  
                props.onResetError(error);
            });
    };

    const backToMainPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){
            backToMainClick();
        }
    };


    return(
        <>
            <div>                
                <div className={classes.bottom}>
                    <div className={classes.bottomTitle}>{Translate('N_General_unibeam_6')}</div>
                    <div>{Translate('N_General_unibeam_7')}</div>
                    <a  id='backToLoginLink' 
                        className={classes.backLink} 
                        onClick={backToMainClick}
                        onKeyPress={backToMainPress}
                        tabIndex={0}               
                    >
                        {Translate('N_General_unibeam_8')}
                    </a>       
                </div>
            </div>           
        </>
    );
}
export default PushBottom;